﻿function getForm() {
    return $("[data-car-launch-calendar-form]");
}

function submitForm() {
    const form = getForm();
    form.submit();
}

export function setupCarLaunchCalendar() {
    $(document).on("change", "[data-car-launch-calendar] #Year", submitForm);

}